
// 検索マッチ用 ひらがな・カタカナリスト
const h = Array(86).fill('ぁ').map((a, b) => String.fromCharCode(a.charCodeAt() + b));
const k = Array(86).fill('ァ').map((a, b) => String.fromCharCode(a.charCodeAt() + b));

// 検索文字列で絞り込み（大文字小文字・ひらがなカタカナ区別なし）
// 参考: https://qiita.com/H40831/items/5b44ef00cebf532087db
export function strFuzzyMatch(searchText: string, text: string): string | null {
  let result = null;
  if (searchText) {
    // 正規表現で使用する文字をエスケープ
    const escapedSearchText = escapeRegExp(searchText);
    // ひらがなカタカナを区別しない正規表現文字列を作成
    const chars = escapedSearchText.split('').map((char) => {
      const katakana = h2k(char);
      const hiragana = k2h(char);
      if (hiragana === katakana) {
        return char;
      }
      return `(${hiragana}|${katakana})`;
    });
    // 正規表現文字列を結合
    const regExp = new RegExp(`(${chars.join('')})`, 'i'); // i: 大文字小文字区別しない
    // 正規表現でマッチ
    const matchArray = text.match(regExp);
    if (matchArray && matchArray.length) {
      result = matchArray[0];
    }
  }
  // マッチ箇所の文字列 または nullを返却
  return result;
}

function escapeRegExp(s: string) { // 正規表現エスケープ
  return s.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
}

function h2k(s: string) { // ひらがな -> カタカナ
  return s.split('').map((a) => k[h.indexOf(a)] ? k[h.indexOf(a)] : a).join('');
}

function k2h(s: string) { // カタカナ -> ひらがな
  return s.split('').map((a) => h[k.indexOf(a)] ? h[k.indexOf(a)] : a).join('');
}
